/* eslint-disable react-hooks/exhaustive-deps */
import { Button, DatePicker, Modal, Select, Table } from 'antd';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getCustomerDevicesApi } from '../../api/customerApi';
import {
  NAMESPACE,
  NOTIFIES,
  DECODED_ACCESS_TOKEN,
} from '../../constants/system.keys';
import * as ACTIONS from '../../redux/actions';
import './index.scss';
import storageService from '../../services/storage.service';
import { useDispatch, useSelector } from 'react-redux';
import { getRecoveryHistoryEventOfCameraPage } from '../../redux/recovery/reducer';
import {
  updateRecoveryCameraPage,
  updateRecoveryHistoryEventOfCameraPage,
} from '../../redux/recovery/action';

const PAGE_SIZE = 10;

const { RangePicker } = DatePicker;
const { Option } = Select;

const LogEventCamera = ({ dataDevice, variantPage = '' }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [current, setCurrent] = useState(1);
  const [dataPageSize, setDataPageSize] = useState(PAGE_SIZE);
  const [visible, setVisible] = useState(false);
  const [dataRangerGateway, setDataRangerGateway] = useState([
    moment().subtract(1, 'month').valueOf(),
    moment().valueOf(),
  ]);
  const { filterType: recoveryFilterType } = useSelector(
    getRecoveryHistoryEventOfCameraPage,
  );
  const [dataFilterType, setDataFilterType] = useState(
    'camera_disconnection_session',
  );
  const [dataLogGateway, setDataLogGateway] = useState({});
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const { namespace } = useSelector((state) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    if (dataDevice) {
      setIsLoading(true);
      onFilterLog(dataDevice?.serial, dataFilterType);
    }
  }, [dataDevice]);

  const onFilterLog = async (serial, type, fromTime, toTime, limit, offset) => {
    const token = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
    const dataQuery = {
      serial,
      fromTime: fromTime ?? moment('01-01-2019', 'DD-MM-YYYY').valueOf(),
      toTime: toTime ?? moment().valueOf(),
      limit: limit ?? PAGE_SIZE,
      offset: offset ?? 0,
      isDownload: 0,
      type,
    };
    const dataRes = await getCustomerDevicesApi(
      token,
      { namespace },
      dataQuery,
    );
    if (dataRes?.data?.deviceReports) {
      setDataLogGateway(dataRes?.data ?? {});
    }
    setIsLoading(false);
  };

  const onDownloadLog = async (
    serial,
    type,
    fromTime,
    toTime,
    limit,
    offset,
  ) => {
    const token = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
    const dataQuery = {
      serial,
      fromTime: fromTime ?? moment().subtract(1, 'month').valueOf(),
      toTime: toTime ?? moment().valueOf(),
      limit: limit ?? PAGE_SIZE,
      offset: offset ?? 0,
      isDownload: 1,
      type,
    };
    const dataRes = await getCustomerDevicesApi(
      token,
      { namespace },
      dataQuery,
    );
    setTimeout(() => {
      if (dataRes?.data) {
        const buttonElement = document.createElement('a');
        buttonElement.href = `data:text/csv;charset=utf-8,${encodeURI(
          dataRes.data,
        )}`;
        buttonElement.target = '_blank';
        buttonElement.download = `report-log.${moment(fromTime).format(
          'DD_MM_YYYY',
        )}-${moment(toTime).format('DD_MM_YYYY')}.csv`;
        buttonElement.click();
      } else {
        ACTIONS.openMessage(NOTIFIES.WARNING, 'No data export');
      }
      setIsLoadingExport(false);
    }, 800);
  };

  const onPageChange = (newPage, pageSize) => {
    setCurrent(newPage);
    setDataPageSize(pageSize);
    setIsLoading(true);
    onFilterLog(
      dataDevice?.serial,
      dataFilterType,
      dataRangerGateway[0],
      dataRangerGateway[1],
      pageSize,
      (newPage - 1) * dataPageSize,
    );
  };

  const handleDateRangerChange = (values) => {
    const FromDate =
      values.length > 0 ? values[0].set({ hour: 0, minute: 0, second: 0 }) : '';
    const ToDate =
      values.length > 0
        ? values[1].set({ hour: 23, minute: 59, second: 59 })
        : '';
    setCurrent(1);
    setDataPageSize(PAGE_SIZE);
    setIsLoading(true);
    setDataRangerGateway([
      moment(FromDate).valueOf(),
      moment(ToDate).valueOf(),
    ]);
    onFilterLog(
      dataDevice?.serial,
      dataFilterType,
      moment(FromDate).valueOf(),
      moment(ToDate).valueOf(),
      PAGE_SIZE,
      0,
    );
  };

  const handleSelectType = useCallback(
    (value) => {
      setCurrent(1);
      setDataPageSize(PAGE_SIZE);
      setIsLoading(true);
      setDataFilterType(value);
      if (variantPage === 'camera') {
        dispatch(updateRecoveryHistoryEventOfCameraPage({ filterType: value }));
      }
      onFilterLog(
        dataDevice?.serial,
        value,
        dataRangerGateway[0],
        dataRangerGateway[1],
        PAGE_SIZE,
        0,
      );
    },
    [variantPage, dispatch, dataRangerGateway, dataDevice],
  );

  useEffect(() => {
    if (!dataDevice || variantPage !== 'camera') return;
    if (recoveryFilterType) {
      setTimeout(() => {
        setDataFilterType(recoveryFilterType);
        setIsLoading(true);
        onFilterLog(
          dataDevice?.serial,
          recoveryFilterType,
          dataRangerGateway[0],
          dataRangerGateway[1],
          PAGE_SIZE,
          0,
        );
      }, 100);
    }
  }, [recoveryFilterType, variantPage]);

  const convertHMS = (value) => {
    const sec = parseInt(value, 10); // convert value to number if it's string
    let hours = Math.floor(sec / 3600); // get hours
    let minutes = Math.floor((sec - hours * 3600) / 60); // get minutes
    let seconds = sec - hours * 3600 - minutes * 60; //  get seconds
    // add 0 if value < 10; Example: 2 => 02
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    return hours + ':' + minutes + ':' + seconds; // Return is HH : MM : SS
  };

  const colums1 = [
    {
      title: 'Disconnection time',
      dataIndex: 'startTime',
      key: 'startTime_log',
      render: (text, row) => {
        if (dataFilterType === 'camera_disconnection_session') {
          return (
            <span>
              {row?.content
                ? moment(JSON.parse(row?.content)?.startTime * 1000)
                    .subtract(7, 'hours')
                    .format('HH:mm:ss DD-MM-YYYY')
                : ''}
            </span>
          );
        } else {
          return (
            <span>
              {row?.content
                ? moment(JSON.parse(row?.content)?.startTime * 1000).format(
                    'HH:mm:ss DD-MM-YYYY',
                  )
                : ''}
            </span>
          );
        }
      },
    },
    {
      title: 'Connected time',
      dataIndex: 'endTime',
      key: 'endTime_log',
      render: (text, row) => {
        if (dataFilterType === 'camera_disconnection_session') {
          return (
            <span>
              {row?.content
                ? moment(JSON.parse(row?.content)?.endTime * 1000)
                    .subtract(7, 'hours')
                    .format('HH:mm:ss DD-MM-YYYY')
                : ''}
            </span>
          );
        } else {
          return (
            <span>
              {row?.content
                ? moment(JSON.parse(row?.content)?.endTime * 1000).format(
                    'HH:mm:ss DD-MM-YYYY',
                  )
                : ''}
            </span>
          );
        }
      },
    },
    {
      title: 'Duration',
      dataIndex: 'duration',
      key: 'duration',
      render: (text, row) =>
        convertHMS(
          Math.round(
            moment
              .utc(
                moment(JSON.parse(row?.content)?.endTime * 1000).diff(
                  moment(JSON.parse(row?.content)?.startTime * 1000),
                ),
              )
              .valueOf() / 1000,
          ),
        ),
    },
    {
      title: 'Message',
      dataIndex: 'message',
      key: 'message_log',
      render: (text, row) => (
        <span>{row?.content ? JSON.parse(row?.content)?.message : ''}</span>
      ),
    },
  ];

  const colums2 = [
    {
      title: 'Event time',
      key: 'eventTime',
      dataIndex: 'eventTime',
      render: (text) => moment(text).format('HH:mm:ss DD-MM-YYYY'),
    },
    {
      title: 'Message',
      dataIndex: 'message',
      key: 'message_gateway',
      render: (text, row) => (
        <span>{row?.content ? JSON.parse(row?.content)?.message : ''}</span>
      ),
    },
  ];

  return (
    <div className="log-camera-page">
      <div className="box-customer-header">
        <div className="title-box-customer"></div>
        <Select
          value={dataFilterType}
          style={{ width: '230px', textAlign: 'start', marginRight: '16px' }}
          onChange={handleSelectType}
        >
          <Option value="camera_disconnection_session">
            <span>Camera kết nối trở lại</span>
          </Option>
          <Option value="camera_disconnection_event">
            <span>Camera mất kết nối</span>
          </Option>
        </Select>
        <RangePicker
          allowClear={false}
          defaultValue={[
            moment(dataRangerGateway[0]),
            moment(dataRangerGateway[1]),
          ]}
          format="DD-MM-YYYY"
          onChange={handleDateRangerChange}
          style={{ marginRight: '16px' }}
        />
        <Button
          loading={isLoadingExport}
          size="middle"
          type="primary"
          onClick={() => {
            onDownloadLog(
              dataDevice?.serial,
              dataFilterType,
              dataRangerGateway[0],
              dataRangerGateway[1],
              dataLogGateway?.total,
              0,
            );
            setIsLoadingExport(true);
          }}
        >
          {t('Export report')}
        </Button>
      </div>
      <div className="table-page">
        <Table
          loading={isLoading}
          size="small"
          columns={
            dataFilterType === 'camera_disconnection_session' ||
            dataFilterType === 'gateway_lost_power' ||
            dataFilterType === 'gateway_lost_internet'
              ? colums1
              : colums2
          }
          pagination={{
            onChange: onPageChange,
            pageSize: dataPageSize,
            current,
            total: dataLogGateway?.total,
            position: ['bottomRight'],
            pageSizeOptions: ['10', '20', '50', '100', '200', '400'],
          }}
          dataSource={dataLogGateway?.deviceReports?.map((data, index) => ({
            ...data,
            key: index + 1,
            index: (index + 1) * 1,
          }))}
        />
      </div>
      <Modal
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
        footer={null}
        bodyStyle={{ height: '75vh', padding: '40px' }}
        width={'70%'}
      >
        <iframe
          style={{ width: '100%', height: '100%' }}
          src={
            'http://remote1.beex.vn:2224/remote/10662/a84634c48fc1cbef89183b77764238ccaio4Tj0WZC2ifUzIQMRD5CoIRecarqWq'
          }
          title="Remote"
        ></iframe>
      </Modal>
    </div>
  );
};

export default LogEventCamera;
